module.exports = __webpack_public_path__ + "assets/imgs/gmp/searchAds.ab763cc830c00526bee466a388b6669a.svg";